module.exports = __webpack_public_path__ + "img/req1.75a8bb12.png";